import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const features = [
  {
    icon: FiIcons.FiWind,
    title: "Pure Origins",
    description: "Cold-pressed botanicals sourced from high-altitude farms to preserve nutrient density."
  },
  {
    icon: FiIcons.FiShield,
    title: "Barrier First",
    description: "Every formulation is pH-optimized to respect the delicate acid mantle of your skin."
  },
  {
    icon: FiIcons.FiHeart,
    title: "Ethical Science",
    description: "100% vegan, cruelty-free, and packaged in endlessly recyclable ultraviolet glass."
  }
];

const Philosophy = () => {
  return (
    <section id="philosophy" className="py-24 md:py-40 bg-white">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-20 items-center">
          <div className="order-2 lg:order-1 grid grid-cols-1 sm:grid-cols-2 gap-10">
            {features.map((feature, index) => (
              <motion.div 
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                className="space-y-4"
              >
                <div className="w-12 h-12 flex items-center justify-center bg-stone-50 text-stone-900 border border-stone-100">
                  <SafeIcon icon={feature.icon} className="w-5 h-5" />
                </div>
                <h3 className="font-serif text-xl">{feature.title}</h3>
                <p className="text-stone-500 text-sm font-light leading-relaxed">{feature.description}</p>
              </motion.div>
            ))}
          </div>

          <div className="order-1 lg:order-2">
            <motion.div
              initial={{ opacity: 0, x: 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
            >
              <span className="text-[11px] font-bold tracking-[0.3em] uppercase text-stone-400 block mb-6">Our Core Ethos</span>
              <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-stone-900 mb-8 leading-tight">
                Radiance through <br />
                <span className="italic font-light">intentionality.</span>
              </h2>
              <p className="text-stone-600 font-light leading-relaxed text-lg mb-8">
                We reject the industry's obsession with 'more'. At GlowDock, we focus on the synergy between biological necessity and botanical potency. No fillers, no synthetic perfumes, no compromises.
              </p>
              <div className="flex items-center gap-4 py-4 border-t border-stone-100">
                <div className="w-10 h-10 rounded-full bg-stone-100 flex items-center justify-center overflow-hidden">
                  <img src="https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100" alt="Founder" />
                </div>
                <div>
                  <p className="text-xs font-bold uppercase tracking-widest">Sarah El-Amin</p>
                  <p className="text-[10px] text-stone-400 uppercase">Founding Formulator</p>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Philosophy;